import { ChainId } from '@pancakeswap/chains'

const zeroAddress = '0x0000000000000000000000000000000000000000' as const

// duck typing for native currency, token, token info
export type CurrencyParams =
  | {
      chainId: ChainId
      address: `0x${string}`
      isNative?: false
    }
  | {
      chainId: ChainId
      isNative: true
    }

export type CurrencyKey = `0x${string}`

export type CurrencyUsdResult = Record<CurrencyKey, number>

export type AlchemyTokenPriceByAddress = {
  currency: string
  value: string
  lastUpdatedAt: string
}

export type AlchemyTokenByAddress = {
  network: string
  address: `0x${string}`
  prices: AlchemyTokenPriceByAddress[]
}

export type AlchemyTokenByAddresses = {
  data: AlchemyTokenByAddress[]
}

export function getCurrencyKey(currencyParams?: CurrencyParams): CurrencyKey | undefined {
  if (!currencyParams) {
    return undefined
  }

  if ('isNative' in currencyParams && currencyParams.isNative === true) {
    return zeroAddress
  }
  const { address } = currencyParams
  return address.toLowerCase() as CurrencyKey
}

export function getCurrencyListKey(currencyListParams?: CurrencyParams[]): string | undefined {
  if (!currencyListParams) {
    return undefined
  }

  const currencyKeys = currencyListParams.map(getCurrencyKey).filter((key): key is CurrencyKey => !!key)

  const uniqueKeys = [...new Set(currencyKeys)]

  return uniqueKeys.join(',')
}

export async function getCurrencyUsdPrice(currencyParams?: CurrencyParams): Promise<number> {
  try {
    const prices = await getCurrencyListUsdPrice(currencyParams && [currencyParams])
    const priceKey = getCurrencyKey(currencyParams)
    return (priceKey && prices[priceKey]) ?? 0
  } catch (e) {
    throw new Error(`Failed to fetch currency prices, currency: ${currencyParams}`)
  }
}

export async function getCurrencyListUsdPrice(currencyListParams?: CurrencyParams[]): Promise<CurrencyUsdResult> {
  const requestUrl = '/api/token-prices'
  if (!currencyListParams) {
    throw new Error(`Invalid request for currency prices, request url: ${requestUrl}`)
  }
  const addresses = currencyListParams.map((each) => {
    return {
      network: each.chainId === ChainId.ETHEREUM ? 'eth-mainnet' : 'eth-sepolia',
      address: getCurrencyKey(each),
    }
  })
  const data: CurrencyUsdResult = await fetch(requestUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ addresses }),
  })
    .then((res) => res.json())
    .catch((error) => {
      // Handle any fetch errors here
      console.error('Error fetching data for addresses:', error)
    })

  return data
}
